import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { OrderDetails, OrderLccAlternative, OrderLccSchema, SalesOrderStatus } from "@api/core/logistics/sales-orders/sales-orders.schema";
import { userLoggedOut } from "../auth/authSlice";

type SetOrderDetailsPayload = {
  orderDetails: OrderDetails | undefined;
};

type SetOrderStatusStatePayload = {
  status: SalesOrderStatus;
};

export type OrderDetailsState = {
  orderDetails: OrderDetails | undefined;
  orderLccInfo: OrderLccSchema | undefined;
  orderLccAlternatives: OrderLccAlternative[];
};

const initialState: OrderDetailsState = {
  orderDetails: undefined,
  orderLccInfo: undefined,
  orderLccAlternatives: [],
};

const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    setOrderDetails: (state, action: PayloadAction<SetOrderDetailsPayload>) => {
      state.orderDetails = action.payload.orderDetails;
    },
    setOrderLccInfo: (state, action: PayloadAction<OrderLccSchema>) => {
      state.orderLccInfo = action.payload;
    },
    setOrderLccAlternatives: (state, action: PayloadAction<OrderLccAlternative[]>) => {
      state.orderLccAlternatives = action.payload;
    },
    updateOrderDetailStatus: (
      state,
      action: PayloadAction<SetOrderStatusStatePayload>
    ) => {
      if (state.orderDetails) state.orderDetails.status = action.payload.status;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLoggedOut, (_) => {
      return initialState;
    })
  },
});

export const {
  setOrderDetails,
  setOrderLccInfo,
  setOrderLccAlternatives,
  updateOrderDetailStatus,
} = orderDetailsSlice.actions;

export const selectOrderDetails = (state: RootState) =>
  state.orderDetails.orderDetails;
export const selectOrderLccInfo = (state: RootState) =>
  state.orderDetails.orderLccInfo;
export const selectOrderLccAlternatives = (state: RootState) =>
  state.orderDetails.orderLccAlternatives;

export default orderDetailsSlice.reducer;
